import React, { useState, useEffect } from 'react';
import ChatSidebar from './ChatSidebar';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';

import { getConversationDetail } from "../../services/chatServices";
import { authAtom } from '../../states/auth';
import { useAlert } from "../../contexts/AlertContext";
import { useAtomValue } from 'jotai';
import { useLocation } from "react-router-dom";


const Chat = () => {

  const [conversationId, setConversationId] = useState(null);
  const [inboxConversations, setInboxConversations] = useState(null);
  const location = useLocation();
  const [meetingId, setMeetingId] = useState();
  const [conversationData, setConversationData] = useState({});
  const { showAlert } = useAlert();
  const auth = useAtomValue(authAtom);
  const currentUser = auth?.user?.id;
  const [chatScreenFilter, setChatScreenFilter] = useState({
    no_of_result: 0,
    page: 0,
    search: "",
    filter: "all"
  });

  useEffect(() => {
    // alert(location?.state?.singleInboxItem?.id)
    console.log("location.state", location?.state?.singleInboxItem?.id)
    if (location?.state?.singleInboxItem?.id) {
      setConversationId((prev) => location?.state?.singleInboxItem?.id);
    }


  }, []);

  const getConversationDetailData = async () => {
    try {
      const data = await getConversationDetail(conversationId);
      console.log("------------------datappp-----------------------------------------------------", data.data)
      setConversationData(data?.data)
    } catch (error) {
      console.error("Error fetching chat conversation:", error);
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const reorderConversations = (id) => {
    setInboxConversations(prev => {
      const existingIndex = prev.findIndex(item => item.id === id);
      let updatedList;

      if (existingIndex !== -1) {
        const itemToMove = prev[existingIndex];
        updatedList = [
          itemToMove,
          ...prev.slice(0, existingIndex),
          ...prev.slice(existingIndex + 1)
        ];
      } else {
        setChatScreenFilter({ ...chatScreenFilter })
      }

      return updatedList;
    });
  }

  useEffect(() => {
    // alert(conversationId)
    if (conversationId != null) {
      getConversationDetailData();
    }

  }, [conversationId])

  return (
    <div className="chat-app d-flex flex-column flex-lg-row gap-3">
      <ChatSidebar reorderConversations={reorderConversations} inboxConversations={inboxConversations} setInboxConversations={setInboxConversations} preSelectedConversationId={location?.state?.singleInboxItem?.id} conversationId={conversationId} setConversationId={setConversationId} chatScreenFilter={chatScreenFilter} setChatScreenFilter={setChatScreenFilter} />
      <div className="chat-wrapper rounded-4 flex-grow-1 d-flex flex-column">
        {conversationId  && <>
          <ChatHeader setConversationId={() => setConversationId()} conversationData={conversationData} chatScreenFilter={chatScreenFilter} setChatScreenFilter={setChatScreenFilter} meetingId={meetingId} setMeetingId={setMeetingId} />
          <ChatMessages reorderConversations={reorderConversations} inboxConversations={inboxConversations} setInboxConversations={setInboxConversations} conversationId={conversationId} conversationData={conversationData} currentUserId={currentUser} meetingId={meetingId} setMeetingId={setMeetingId} />
        </> ||
          <div className="bg-gray-50 d-flex flex-column align-items-center justify-content-center h-100 text-center">
            <img src="images/chat-messaging-icon.svg" alt="Chat Messaging Icon" />
            <h2 className="fs-36 fw-semibold text-gray-700 mt-3 mb-1">
              Welcome to AssistChat
            </h2>
            <p className="fs-20 fw-medium text-gray-500 mb-0">
              It all starts with a hello—type your message and we're good to go!
            </p>
          </div>
        }
      </div>
    </div>
  );
};

export default Chat;
